export default function buildPublicFeedQuery(baseUrl, externalFormId, locale) {
  const encodedFormId = btoa(externalFormId)
  const url = new URL(`${baseUrl}/external/form/${encodedFormId}/${locale}`)
  return url.href
}
